import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { CommonModule } from '@angular/common'
import * as fromRolePermissions from '../role-permissions.reducer'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { ShowModalRoutingModule } from './show-modal-routing.module'
import { RolePermissionsEffects } from '../role-permission.effects'
import { ConfigurationOptionModule } from '../../configuration-option/configuration-option.module'
import { ProductModule } from '../../product/product.module'
import { RolePermissionsService } from '../role-permissions.service'
import { RolePermissionsSerializer } from '../role-permissions.serializer'
@NgModule({
  imports: [
    StoreModule.forFeature(
      fromRolePermissions.FEATURE_NAME,
      fromRolePermissions.rolePermissionsReducer
    ),
    EffectsModule.forFeature([RolePermissionsEffects]),
    TooltipModule.forRoot(),
    ConfigurationOptionModule,
    ShowModalRoutingModule,
    ProductModule,
    CommonModule
  ],
  providers: [
    RolePermissionsService,
    {
      provide: RolePermissionsSerializer,
      useClass: RolePermissionsSerializer
    }
  ]
})
export class ShowModalModule {}
